<template>
  <div class="ana_wrapper">
    <div class="ana_content">
      <div class="left_area">
        <img src="~assets/images/analyst.png" alt />
      </div>
      <div class="right_area">
        <div class="name">{{analystName}}</div>
        <div class="info">
          {{analystDe}}
        </div>
      </div>
    </div>
    <div class="strage_box">
      <strageList :strageData='strageData' @loadMore="loadMore('more')"/> 
    </div>
  </div>
</template>

<script>
import strageList from "./components/strageList";
import {toast} from 'assets/commonjs/toast';
import { getStore, setStore} from "assets/commonjs/storage";
export default {
  data() {
    return {
      detailInfo:{},
       analystDe:'',
       analystName:'',
       companyId:1,
       pageNum:0,
       pageSize:6,
       strageData:[],
    }
  },
   components: {strageList},
   mounted(){
     this.pageNum = 0;
     this.id = this.$route.params.id.slice(1)
    

    if(this.id){
      this.getStrageData(this.id,'')
    }
  },
  
  methods:{
    getStrageData(id,type){
      let data ={
        companyId:this.companyId,
        analystId:id,
        pageNum:this.pageNum,
        pageSize:this.pageSize,
      }
      this.$api.strageList.getStrageData(data).then(res =>{
        let data = res.data.result;
        let ampClass;
        let productPramas = [];
        for (let i in data) {
          if (getStore("patternLabel") == "redGreen") {
            if (data[i].tendency == 0) {
              ampClass = "red";
            } else {
              ampClass = "green";
            }
          } else {
            if (data[i].tendency == 0) {
              ampClass = "green";
            } else {
              ampClass = "red";
            }
          }

          this.$set(data[i], "pro", ampClass);
        }
        if(res.data && res.data.code == 0){
           if(type == 'more'){
            if(res.data.result.length == 0){
                 toast('没有更多数据了')
               }
             this.strageData  =  this.strageData.concat(res.data.result)
          }else{
            this.strageData = res.data.result
             this.analystDe = res.data.result[0].analystDescription
            this.analystName =res.data.result[0].analystName
          } 
        }
      })
    },
    loadMore(type){
      this.pageNum += this.pageSize
      this.getStrageData(this.id,type)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
.ana_wrapper {
  background: #f0f1f5;
}
.ana_content {
  display: flex;
  // align-items: center;
  background: #fff;
  padding: .4rem 0.45rem .4rem 0.3rem;
  .left_area {
    font-size: 0;
    img {
      @include wh(0.7rem, 0.7rem);
    }
    margin-right:.2rem;
  }
  .right_area {
    .name {
      @include sc(0.28rem, #485266);
      font-weight: bold;
      margin-bottom: .2rem;
    }
    .info {
      @include sc(0.28rem, #333);
    }
  }
}
.strage_box {
  padding-bottom:.5rem;
  margin-top: .2rem;
}
</style>